/**
 * useCamera — SVG icon components
 */

import React from 'react';

export const IconClose = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const IconSwitchCamera = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  </svg>
);

export const IconFlashOn = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M13 2L4.5 13.5H11L10 22L20.5 10.5H14L13 2Z" />
  </svg>
);

export const IconFlashOff = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 2L4.5 13.5H11L10 22L20.5 10.5H14L13 2Z" />
  </svg>
);

export const IconFlashAuto = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 2L4.5 13.5H11L10 22L20.5 10.5H14L13 2Z" />
    <text x="12" y="17" textAnchor="middle" fontSize="7" fontWeight="bold" fill="currentColor" stroke="none">A</text>
  </svg>
);

// Torch icon for 3-state torch mode:
//  - 'off':  outline bolt
//  - 'auto': outline bolt with "A" marker
//  - 'on':   filled bolt
export function TorchIcon({ mode }: { mode: 'off' | 'on' | 'auto' }) {
  if (mode === 'on') return <IconFlashOn />;
  if (mode === 'auto') return <IconFlashAuto />;
  return <IconFlashOff />;
}

export const IconFocus = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <circle cx="12" cy="12" r="3" />
    <path strokeLinecap="round" d="M3 12h3m12 0h3M12 3v3m0 12v3" />
  </svg>
);

export const IconZoomIn = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <circle cx="11" cy="11" r="7" />
    <path strokeLinecap="round" d="M21 21l-4.35-4.35M8 11h6M11 8v6" />
  </svg>
);

export const IconZoomOut = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <circle cx="11" cy="11" r="7" />
    <path strokeLinecap="round" d="M21 21l-4.35-4.35M8 11h6" />
  </svg>
);

export const IconCamera = () => (
  <svg className="w-16 h-16 mx-auto mb-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
